import moment from "moment";
import PropTypes from "prop-types";
import React, { use, useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";

const MovMet = ({ show, onSendClick, onCloseClick, orders }) => {
  useEffect(() => {
    console.log(orders);
  }, [orders]);

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 ">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15">
            <p className="text-muted mb-0">
              <div className="text-center">
                <h5>
                  The MOV has been reached for the Supplier:
                  <br />
                  <b>{orders[0]?.supplierName}</b> <br /> The following orders
                  will be placed
                </h5>
              </div>
              <br />
              <br />
              {orders?.map((order) => (
                <div key={order.id}>
                  <p>
                    <b>Product:</b> {order.productName} <br />
                    <b>Price:</b> $ {order.suoTotalPrice} <br />
                    <b>Order Date:</b>{" "}
                    {moment(order.suoDateCreated).format(
                      "MMMM Do YYYY, h:mm a"
                    )}{" "}
                    <br />
                  </p>
                </div>
              ))}
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Close
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger "
            id="send-record"
            onClick={() => onSendClick(orders)} // This is the function that will be called when the button is clicked
          >
            Yes, Send it!
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

MovMet.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
};

export default MovMet;
